'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _barChart = require('./barChart.html');

var _barChart2 = _interopRequireDefault(_barChart);

var _barChart3 = require('./barChart.controller');

var _barChart4 = _interopRequireDefault(_barChart3);

require('./barChart.styl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var barChartComponent = {
  restrict: 'E',
  bindings: {
    title: '<',
    settings: '<',
    data: '<'
  },
  template: _barChart2.default,
  controller: _barChart4.default
};

exports.default = barChartComponent;


// WEBPACK FOOTER //
// ./client/app/common/charting/barChart/barChart.component.js